var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.startArrayRendering)?_c('v-client-table',{ref:_vm.referenceTable,staticClass:"displayNoneVuePagination",attrs:{"data":_vm.etatsHistoriques,"columns":_vm.columns,"options":_vm.options},on:{"loaded":_vm.finLoading,"loading":_vm.debutLoading},scopedSlots:_vm._u([{key:"creationTime",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.func.formatDate(row.creationTime))+" ")]}},{key:"creatorUserId",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.getUser(row.creatorUserId))+" ")]}},{key:"etatAvant",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.$t(_vm.getEtatMontage(row.etatAvant)))+" ")]}},{key:"etatApres",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.$t(_vm.getEtatMontage(row.etatApres)))+" ")]}},{key:"commentaire",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.commentaire)+" ")]}}],null,false,974953524)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }